export const deliverTypeEnums = {
  DRYMEAL: '干粉',
  LIQUID: 'Liquid'
}



// WEBPACK FOOTER //
// ./src/constants/enums.js